module.exports = "<div class=\"application-bar\">\r\n    <div class=\"pull-left\">\r\n        <h3 class=\"page-title\">{{ pageTitle }}</h3>\r\n    </div>\r\n    <div class=\"pull-right text-right no-padding\">\r\n        <h3 class=\"page-actions\">\r\n            <ng-content></ng-content>\r\n        </h3>\r\n    </div>\r\n    \r\n</div>\r\n<div class=\"row application-bar\">\r\n    <div class=\"no-padding col-xs-12\">\r\n    </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/app/shared/components/page-header/page-header.component.html
// module id = ../../../../../src/app/shared/components/page-header/page-header.component.html
// module chunks = main